import TicketTypeCard from './TicketTypeCard'

export default TicketTypeCard
